import Vue from "vue";
import Vuex from "vuex";
import { dashboard } from "./dashboard";
import { estimatorTemplates } from "./estimator-templates";
import { exceptionLogs } from "./exception-logs";
import { invoices } from "./invoices";
import { levyCollectionOverrides } from "./levy-collection-overrides";
import { levyCollectionProviders } from "./levy-collection-providers";
import { levyCollectionRiskFactors } from "./levy-collection-risk-factors";
import { levyCollections } from "./levy-collections";
import { levyEstimator } from "./levy-estimator";
import { lookups } from "./lookups";
import { notices } from "./notices";
import { noticeTemplates } from "./notice-templates";
import { notifications } from "./notifications";
import { prismsUsers } from "./prisms-users";
import { providers } from "./providers";
import { providerContacts } from "./provider-contacts";
import { notes } from "./notes";
import { roles } from "./roles";
import { sandboxes } from "./sandboxes";
import { scheduledJobs } from "./scheduled-jobs";
import { searches } from "./searches";
import { system } from "./system";
import { systemLogs } from "./system-logs";
import { users } from "./users";
import { authenticationLogs } from "./authentication-logs";
import * as dashboardMutation from "./dashboard/mutation-types";
import * as exceptionLogsMutation from "./exception-logs/mutation-types";
import * as systemLogMutation from "./system-logs/mutation-types";
import * as invoiceMutation from "./invoices/mutation-types";
import * as levyCollectionOverridesMutation from "./levy-collection-overrides/mutation-types";
import * as levyCollectionProvidersMutation from "./levy-collection-providers/mutation-types";
import * as levyCollectionRiskFactorsMutation from "./levy-collection-risk-factors/mutation-types";
import * as levyEstimatorMutation from "./levy-estimator/mutation-types";
import * as noticeTemplatesMutation from "./notice-templates/mutation-types";
import * as levyCollectionsMutation from "./levy-collections/mutation-types";
import * as noticesMutation from "./notices/mutation-types";
import * as notificationsMutation from "./notifications/mutation-types";
import * as prismsUsersMutation from "./prisms-users/mutation-types";
import * as providersMutation from "./providers/mutation-types";
import * as providerContactsMutation from "./provider-contacts/mutation-types";
import * as notesMutation from "./notes/mutation-types";
import * as rolesMutation from "./roles/mutation-types";
import * as searchesMutation from "./searches/mutation-types";
import * as scheduledJobsMutation from "./scheduled-jobs/mutation-types";
import * as systemLogsMutation from "./system-logs/mutation-types";
import * as authenticationLogsMutation from "./authentication-logs/mutation-types";


Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV === "development",
  modules: {
    dashboard,
    estimatorTemplates,
    exceptionLogs,
    invoices,
    levyCollectionOverrides,
    levyCollectionProviders,
    levyCollectionRiskFactors,
    levyCollections,
    levyEstimator,
    lookups,
    notices,
    noticeTemplates,
    notifications,
    prismsUsers,
    providerContacts,
    notes,
    providers,
    roles,
    sandboxes,
    scheduledJobs,
    searches,
    system,
    systemLogs,
    users,
    authenticationLogs
  }
});

export default store;

export function resetState() {
  store.commit(dashboardMutation.STATE_RESET);
  store.commit(exceptionLogsMutation.STATE_RESET);
  store.commit(systemLogMutation.STATE_RESET);
  store.commit(invoiceMutation.STATE_RESET);
  store.commit(levyCollectionOverridesMutation.STATE_RESET);
  store.commit(levyCollectionProvidersMutation.STATE_RESET);
  store.commit(levyCollectionRiskFactorsMutation.STATE_RESET);
  store.commit(noticeTemplatesMutation.STATE_RESET);
  store.commit(levyCollectionsMutation.STATE_RESET);
  store.commit(levyEstimatorMutation.STATE_RESET);
  store.commit(noticesMutation.STATE_RESET);
  store.commit(notificationsMutation.STATE_RESET);
  store.commit(prismsUsersMutation.STATE_RESET);
  store.commit(providersMutation.STATE_RESET);
  store.commit(providerContactsMutation.STATE_RESET);
  store.commit(notesMutation.STATE_RESET);
  store.commit(rolesMutation.STATE_RESET);
  store.commit(searchesMutation.STATE_RESET);
  store.commit(scheduledJobsMutation.STATE_RESET);
  store.commit(systemLogsMutation.STATE_RESET);
  store.commit(authenticationLogsMutation.STATE_RESET);
}
